<template>
<div :class="mode">


<div class="auth_animation_layer animate_class " ref="auth_animation_layer" v-if="!$store.state.ui.apploaded">
  <h1>VERIFYHUB</h1>  
  <p class="animate_class auth_text" ref="auth_text">Sustainability Management System</p>
  <div class="auth_loader animate_class" ref="auth_loader">
    <img  :src="require('../../assets/Infinity-2.1s-84px.svg')" class=" " >
  </div>
  

</div>
<div class="auth_animation_bg_layer animate_class " ref="auth_animation_bg_layer"  v-if="!$store.state.ui.apploaded">
  

</div>


<div class="layout_app">
  

<Topbar></Topbar>
  <OffcanvasMenu></OffcanvasMenu>
  <Notifications></Notifications>
  <leftSidebar></leftSidebar>
  <div class="main_content_area animate_class" :style="'padding-left:'+menuleft">
    
    <div class="content_area">
    <router-view ></router-view>
  </div>
  </div>


<DeleteDialog />
<MailTemplateModal />
<TicketModal />
<NotificationsModal />
<SearchModal />
<Toast position="bottom-right" group="br" />
<SearchArea />
<SupplierCustomAttributesModal />

</div>  
</div>
</template>

<script>
export default {

  name: 'App',

  data () {
    return {
      
    }
  },
  computed:{
    menuleft()
    {
      if(this.$store.state.ui.viewdevice=="desktop")
      {
        if(this.$store.state.ui.menuopen)
        {
          return "240px"
        }
        else{
          return "76px"
        }
      }
      else{
        return "0px"
      }
      
    },
    mode()
    {
      if(this.$store.state.auth.user.preflang_id==3)
      {
        return "light_mode"
      }

      if(this.$store.state.auth.user.preflang_id==15)
      {
        return "light_mode"
      }
    }
  },
  async mounted(){

    if(!this.$store.state.auth.user)
    {
      await this.getUserData()
      /*
      await setTimeout(()=>{
        let auth_animation_layer = this.$refs.auth_animation_layer
        let auth_animation_bg_layer = this.$refs.auth_animation_bg_layer
        auth_animation_layer.classList.add("auth_animation_layer_closed_full");
        auth_animation_bg_layer.classList.add("auth_animation_bg_layer_closed_full");
      },10)
      */
    }
    else{
        /*
        let auth_animation_layer = this.$refs.auth_animation_layer
        let auth_animation_bg_layer = this.$refs.auth_animation_bg_layer
        auth_animation_layer.classList.add("auth_animation_layer_closed_full");
        auth_animation_bg_layer.classList.add("auth_animation_bg_layer_closed_full"); 
         */
    }
    
  },
  methods:{
    
  }
};
</script>

<style lang="css" scoped>
</style>